import config from "config/config";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import { Box, VStack, Button, Image } from "@chakra-ui/react";
import { SectionHeader } from "modules/common/components";
import type { HowItWorksProps } from "../HowItWorks.types";

export const HowItWorksContainer = ({ cards, title, preheader, buttonText, uaEvent, gaEvent }: HowItWorksProps) => {
  const handletrackEvents = () => {
    trackUAEvent(uaEvent);
    trackCustomEvent(gaEvent);
  };

  return (
    <Box pt={10} px={4} position="relative" pb="40%">
      <VStack spacing={10} align="stretch" mx="auto">
        <SectionHeader header={title} preheader={preheader} alignItems="flex-start" spacing={4} />
        <VStack spacing={10}>{cards}</VStack>
      </VStack>
      <Button
        as="a"
        href={`${config.funnelUrl}/claims/new`}
        mt={6}
        px={10}
        width={{ base: "100%", md: "fit-content" }}
        onClick={handletrackEvents}
        title={buttonText}
      >
        {buttonText}
      </Button>
      <Image
        src={`${config.staticUrl}/i/homepage/hiw-cloud-and-plane.svg`}
        w="95%"
        position="absolute"
        mt="-20px"
        pointerEvents="none"
        zIndex="1"
      />
    </Box>
  );
};
